import React, { useContext, useState } from 'react'
import ProductContext from '../context/ProductContext'
import makeStyles from '@mui/styles/makeStyles'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import { Button, Theme } from '@mui/material'
import Tooltip from '@mui/material/Tooltip'
import { decodeHtml } from '../../../utils/misc'
import ResponsiveDialog from '@components/ResponsiveDialog'
import { usePromoCodesQuery } from '@graphql/queries/__generated__/promo-codes.generated'

const useStyles = makeStyles((theme: Theme) => ({
  promoCard: {
    margin: '20px 0 10px 0',
    padding: '14px',
    borderRadius: '8px',
  },

  promoTitle: {
    fontSize: 13,
    fontWeight: 700,
    display: 'flex',
    alignItems: 'center',
  },

  copyBtn: {
    background: 'none',
    border: 'none',
    color: '#ffffff',
    cursor: 'pointer',
    fontSize: '20px !important',
    padding: theme.spacing(0.25),
    opacity: 0.8,
    marginLeft: '5px',
    '&:hover': {
      opacity: 1,
    },
  },
}))

const ProductPromoCode = () => {
  const classes = useStyles()
  const { reflection } = useContext(ProductContext)
  const [open, setOpen] = React.useState(false)
  const [isOpenDialog, setIsOpenDialog] = useState(false)
  const { data: promoCodesData } = usePromoCodesQuery({
    variables: { first: 1, productSpecifics: reflection.pk.toString() },
    skip: !reflection?.pk,
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first',
  })

  if (!promoCodesData?.promoCodes.edges.length) return null

  const copyToClipboard = async (text: string) => {
    try {
      await navigator.clipboard.writeText(text)
      setOpen(true)
      setTimeout(() => setOpen(false), 2000)
    } catch (err) {
      console.error('Failed to copy:', err)
    }
  }
  const promoCode = promoCodesData.promoCodes.edges.map(({ node }) => node)[0]

  return (
    <>
      <div className={`${classes.promoCard} bg-secondary text-white`}>
        <div className='flex items-center justify-between flex-wrap'>
          <div className={classes.promoTitle}>
            {promoCode.name}{' '}
            <Tooltip
              title='Copied to clipboard'
              open={open}
              placement='bottom'
              classes={{ tooltip: '!bg-black !text-11' }}
              disableHoverListener
            >
              <ContentCopyIcon onClick={() => copyToClipboard(promoCode.token)} className={classes.copyBtn} />
            </Tooltip>
          </div>
          <Button
            variant='text'
            size='small'
            sx={{
              p: 0,
              minWidth: 'auto',
              textTransform: 'none',
              color: '#ffffff',
              justifySelf: 'end',
            }}
            onClick={() => setIsOpenDialog(true)}
          >
            Read more
          </Button>
        </div>
      </div>

      <ResponsiveDialog title={promoCode.name} isOpenDialog={isOpenDialog} setIsOpenDialog={setIsOpenDialog}>
        <div>{decodeHtml(promoCode.description)}</div>
      </ResponsiveDialog>
    </>
  )
}

export default ProductPromoCode
